// useChatStream - 聊天消息流式发送核心（**逻辑已迁入 @huyu/core 内核**）
//
// 本文件只是薄包装：对外 API 与旧版逐字兼容，后台聊天 UI 零改动。
//   逻辑真源 → HuYu-Clients/HuYu-Clients-Core/core/src/ai/session.ts      （状态机，零框架、可单测）
//              HuYu-Clients/HuYu-Clients-Core/core/src/vue/useChatStream.ts（Vue 响应式门面）
//   传输真源 → HuYu-Clients/HuYu-Clients-Core/core/src/ai/transport.ts    （createFetchTransport）
//
// 🔁 2026-10-28：原先这里把内核 payload 逐字段搬进 chatWithMultiVector、再由它重建一次请求体，
//    等于同一份请求体拼三遍。现在直接用内核传输层，只保留本端专属配置（baseUrl / token）。
//
// 四端共用同一份内核：后台（Vue3+Element）、AI H5、渔业小程序（uni-app）、官网（React 直用 ai 内核）。
import { useChatStream as useCoreChatStream } from '@huyu/core/vue'
import { createFetchTransport } from '@huyu/core/ai'
import { getToken } from '@/modules/huyu-framework/backend/utils/auth'

/** 内核传输层：端点沿用 OpenAI 兼容的 /v1/chat/completions（后端 AiChatController 网关） */
const huyuTransport = createFetchTransport({
  baseUrl: import.meta.env.VITE_APP_BASE_API,
  getToken,
})

export function useChatStream(options = {}) {
  return useCoreChatStream({ ...options, transport: options.transport || huyuTransport })
}

export default useChatStream
